import { Component, Inject, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { SelectedSite } from './selected-site';
import { TylerMatTableDataSource } from '../../angular-material/extended.class';
import { YearService } from '../../year/year.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { LoginService } from '../../../shared-modules/login/login.service';
import { UserPermission } from '../../user/user-permission.model';
import { GradeLevelLookup } from '../../lookup/grade-level-lookup.model';
import { LookupService } from '../../lookup/lookup.service';
import { take } from 'rxjs/operators';
import { detailExpand } from '../../angular-material/mat-animations';
import { Year } from '../../year/year.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
	selector: 'app-selected-sites-dialog',
	templateUrl: './selected-sites-dialog.component.html',
	styleUrls: ['./selected-sites-dialog.component.css'],
	animations: [detailExpand],
})
export class SelectedSitesDialogComponent implements OnInit, OnDestroy {

	// Properties
	schools: SelectedSite[] = [];
	types: string[] = [];
	tableData = new TylerMatTableDataSource();
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	viewOnly = false;
	subscriptions: Subscription[] = [];
	allSelected = false;
	V9UserPermissions: UserPermission[] = [];
	includeGradeLevels = false;
	includeYears = false;
	gradeLevels: GradeLevelLookup[] = [];
	selectedGradeLevelIds: number[] = [];
	selectedSites: SelectedSite[] = [];
	years: Year[] = [];
	selectedSiteYearIds: number[] = [];
	columnsToDisplay = ['Selected', 'SchoolName', 'SchoolType'];
	moreColumns = ['expandedDetailGradeLevel'];
	// Class Functions
	constructor(
		private dialogBox: MatDialogRef<SelectedSitesDialogComponent>,
		private yearService: YearService,
		private loginService: LoginService,
		private lookupService: LookupService,
		@Inject(MAT_DIALOG_DATA) private data: any
	) { }

	ngOnDestroy() { }

	// Event Functions
	ngOnInit() {
		// POST: obtains the schools from the server

		// Getting the injected data

		let schoolIds: number[] = [];
		if (this.data) {
			// if (this.data.selectedSites) {
			// 	selectedSites = this.data.selectedSites;
			// 	schoolIds = selectedSites.split(',');
			// 	for (let i = 0; i < schoolIds.length; i++) {
			// 		schoolIds[i] = Number.parseInt((<string>schoolIds[i]).trim(), 10);
			// 	}
			// }
			// if (this.data.schoolIds) {
			// 	schoolIds = this.data.schoolIds;
			// 	for (let i = 0; i < schoolIds.length; i++) {
			// 		if (i > 0) {
			// 			selectedSites += ',';
			// 		}
			// 		selectedSites += schoolIds;
			// 	}
			// }
			if (this.data.selectedSites) {
				this.selectedSites = this.data.selectedSites;
				schoolIds = this.selectedSites.map(o => o.Id);
			}
			this.viewOnly = this.data.viewOnly;
			if (this.data.includeGradeLevels) {
				this.columnsToDisplay = ['More', 'Selected', 'SchoolName', 'SchoolType'];
				this.moreColumns = ['expandedDetailGradeLevel'];
				this.includeGradeLevels = this.data.includeGradeLevels;
				this.getGradeLevels();
				if (this.data.gradeLevelIds && this.data.gradeLevelIds.length > 0) {
					this.selectedGradeLevelIds = this.data.gradeLevelIds;
				}
			}
			else if (this.data.includeYears) {
				this.columnsToDisplay = ['More', 'Selected', 'SchoolName', 'SchoolType'];
				this.moreColumns = ['expandedDetailYear'];
				this.includeYears = this.data.includeYears;
				if (this.data.siteYearIds && this.data.siteYearIds.length > 0) {
					this.selectedSiteYearIds = this.data.siteYearIds;
				}
			}
		}


		// Getting the possible selected sites
		this.schools = [];
		this.types = [];
		if (this.data.availableSchools) {
			if (this.loginService.LoginSettings.V10 && (this.data.availableSchools.length > 0 || this.data.maintainStudentsDistrictWide)) {
				this.subscriptions.push(this.yearService.getSchoolsBySchoolIds(this.data.availableSchools).subscribe(schools => {
					schools.forEach(school => {
						const selectedSite = new SelectedSite();
						selectedSite.Id = school.Id;
						selectedSite.SchoolName = school.SchoolName;
						selectedSite.SchoolCode = school.SchoolCode;
						selectedSite.SchoolDescription = '';
						selectedSite.SchoolType = school.SchoolType;
						this.schools.push(selectedSite);

						if (!this.types.includes(school.SchoolType)) {
							this.types.push(school.SchoolType);
						}
						// Getting the initially selected schools
						if (schoolIds.includes(school.Id)) {
							selectedSite.selected = true;
						}
					});
					if (this.includeGradeLevels) {
						this.getGradeLevels();
					}
					this.setGridData();
				}));
			}
			else {
				const schools = _.sortBy(this.yearService.schools, ['SchoolCode', 'SchoolName']);
				schools.forEach(obj => {
					const school = new SelectedSite();
					school.Id = obj.Id;
					school.SchoolName = obj.SchoolName;
					school.SchoolCode = obj.SchoolCode;
					school.SchoolDescription = obj.SchoolDescription;
					school.SchoolType = obj.SchoolType;
					this.schools.push(school);

					if (!this.types.includes(school.SchoolType)) {
						this.types.push(school.SchoolType);
					}
					// Getting the initially selected schools
					if (schoolIds.includes(school.Id)) {
						school.selected = true;
					}
				});
			}
			if (this.includeGradeLevels) {
				this.getGradeLevels();
			}
			this.setGridData();
		}
		else {
			if (this.loginService.LoginSettings.V10) {
				this.yearService.years.filter(o => o.Description == this.yearService.defaultYear.Description).forEach(obj => {
					const school = new SelectedSite();
					school.Id = obj.SchoolID;
					school.SchoolName = obj.SchoolName;
					school.SchoolCode = obj.SchoolCode;
					school.SchoolDescription = '';
					school.SchoolType = obj.SchoolType;
					this.schools.push(school);

					if (!this.types.includes(school.SchoolType)) {
						this.types.push(school.SchoolType);
					}
					// Getting the initially selected schools
					if (schoolIds.includes(school.Id)) {
						school.selected = true;
					}
				});
			} else {
				const schools: Year[] = [];
				this.yearService.yearsForC360.forEach(element => {
					const isActiveSite = this.yearService.schools.find(s => s.Id == element.SchoolID);
					if (isActiveSite != undefined && isActiveSite) {
						schools.push(element);
					}
				});
				if (this.includeYears) {
					schools.forEach(y => {
						const obj = _.cloneDeep(y);
						let school = this.schools.find(o => o.Id == obj.SchoolID);
						if (!school) {
							school = new SelectedSite();
							school.Id = obj.SchoolID;
							school.SchoolName = obj.SchoolName;
							school.SchoolCode = obj.SchoolCode;
							school.SchoolDescription = '';
							school.SchoolType = obj.SchoolType;
							this.schools.push(school);
						}

						if (!this.types.includes(school.SchoolType)) {
							this.types.push(school.SchoolType);
						}
						// Getting the initially selected schools
						if (schoolIds.includes(school.Id)) {
							school.selected = true;
						}

						// Get selected years
						if (!school.Years) {
							school.Years = [];
						}
						school.Years.push(obj);

						if (this.selectedSiteYearIds.includes(obj.SiteYearId)) {
							obj.selected = true;
						}

					});
				}
				else {
					schools.filter(o => o.Description == this.yearService.defaultYear.Description).forEach(obj => {
						const school = new SelectedSite();
						school.Id = obj.SchoolID;
						school.SchoolName = obj.SchoolName;
						school.SchoolCode = obj.SchoolCode;
						school.SchoolDescription = '';
						school.SchoolType = obj.SchoolType;
						this.schools.push(school);

						if (!this.types.includes(school.SchoolType)) {
							this.types.push(school.SchoolType);
						}
						// Getting the initially selected schools
						if (schoolIds.includes(school.Id)) {
							school.selected = true;
						}
					});
				}
			}

			this.setGridData();
		}
	}

	yearSelected(school: SelectedSite, year: Year) {
		if (school.selected == undefined || school.selected == false) {
			school.selected = true;
		}


			if (!year.selected) {
				school.checkIndeterminate = true;
			}
			else {
				const years: any[] = [];
				school.Years.forEach(y => {
					if (y.selected) {
						years.push(y);
					}
				});
				if (school.Years.length == years.length) {
					school.checkIndeterminate = false;
				}
				else {
					school.checkIndeterminate = true;
				}
			}
	}

	gradeLevelSelected(school: SelectedSite, gradeLavel: GradeLevelLookup) {
		if (school.selected == undefined || school.selected == false) {
			school.selected = true;
		}
		if (!gradeLavel.selected) {
			school.checkIndeterminate = true;
		}
		else {
			const gradeLavels: any[] = [];
			school.GradeLevels.forEach(gl => {
				if (gl.selected) {
					gradeLavels.push(gl);
				}
			});
			if (school.GradeLevels.length == gradeLavels.length) {
				school.checkIndeterminate = false;
			}
			else {
				school.checkIndeterminate = true;
			}
		}
	}

	getGradeLevels() {
		if (this.lookupService.gradeLevelLookups && this.lookupService.gradeLevelLookups.length > 0) {
			this.gradeLevels = _.cloneDeep(this.lookupService.gradeLevelLookups);
			this.updateSchoolGradeLevels();
		}
		else {
			this.lookupService.getGradeLevelsLookupByYearId(this.yearService.defaultYear.Id).pipe(take(1)).subscribe(gradelevels => {
				this.gradeLevels = gradelevels;
				this.lookupService.gradeLevelLookups = _.cloneDeep(gradelevels);
				this.updateSchoolGradeLevels();
			});
		}
	}

	updateSchoolGradeLevels() {
		if (this.includeGradeLevels) {
			if (this.gradeLevels && this.gradeLevels.length > 0 && this.schools && this.schools.length > 0) {
				this.schools.forEach(school => {
					if (this.loginService.LoginSettings.V10) {
						school.GradeLevels = this.gradeLevels.filter(o => o.SiteID == school.Id);
					} else {
						school.GradeLevels = [];
						this.gradeLevels.forEach(gl => {
							if (gl.SiteIDs.includes(school.Id)) {
								school.GradeLevels.push(_.cloneDeep(gl));
							}
						});
					}

					const selectedSchool = this.selectedSites.find(o => o.Id == school.Id);
					if (selectedSchool) {
						school.GradeLevels.forEach(gl => {
							if (selectedSchool.GradeLevels && selectedSchool.GradeLevels.length > 0) {
								if (selectedSchool.GradeLevels.find(o => o.Id == gl.Id) != null) {
									gl.selected = true;
								}
							}
							else if (this.loginService.LoginSettings.V10) { // if no grade levels are passed in, we assume all grade levels are selected.  It's not valid to have a school selected with no grade levels.
								gl.selected = true;
							}
						});
					}
				});
			}
		}
		// ### indeterminate Start ###
		this.schools.forEach(element => {
			const gradeLevels: any[] = [];
			element.GradeLevels.forEach(gl => {
				if (gl.selected) {
					gradeLevels.push(gl);
				}
			});
			if (element.selected && element.GradeLevels.length != gradeLevels.length) {
				element.checkIndeterminate = true;
			}
		});
		// ### indeterminate End ###
	}

	setGridData() {
		// ### indeterminate Start ###
		// this.schools.forEach(element => {
		// 	const gradeLevels: any[] = [];
		// 	element.GradeLevels.forEach(gl => {
		// 		if (gl.selected) {
		// 			gradeLevels.push(gl);
		// 		}
		// 	});
		// 	if (element.selected && element.GradeLevels.length != gradeLevels.length) {
		// 		element.checkIndeterminate = true;
		// 	}
		// });
		// ### indeterminate End ###
		// Setting the table data to the selected sites
		this.tableData.data = this.schools.sort(function (a, b) {
			const siteA = a.SchoolName.toLowerCase();
			const siteB = b.SchoolName.toLowerCase();

			let comparison = 0;

			if (siteA > siteB) {
				comparison = 1;
			}
			else if (siteA < siteB) {
				comparison = -1;
			}

			return comparison;
		});
		this.tableData.sort = this.sort;
	}

	save() {
		// PRE: the save button is clicked
		// POST: returns the selected sites and grade Levels
		this.selectedSites = this.schools.filter(o => o.selected);
		if (this.includeGradeLevels) {
			this.selectedSites.forEach(o => {
				const tempGradeLevels = [];
				o.GradeLevels.forEach(gl => {
					if (gl.selected) {
						gl.SiteID = o.Id;
						tempGradeLevels.push(gl);
					}
				});
				o.GradeLevels = tempGradeLevels;
				// o.GradeLevels = o.GradeLevels.filter(g => g.selected);
			});
		}
		else if (this.includeYears) {
			this.selectedSites.forEach(o => {
				o.Years = o.Years.filter(y => y.selected);
			});
		}
		this.dialogBox.close(this.selectedSites);
	}

	cancel() {
		// PRE: the cancel button is clicked
		// POST: closes the dialog box
		this.dialogBox.close();
	}

	selectAll(type: string) {
		// PRE: a select all link is clicked
		// POST: selects all the schools of the specified type

		// Checking if we can do this operation
		if (this.viewOnly) {
			return;
		}

		// Selecting all schools
		this.schools.forEach(school => {
			if (school.SchoolType == type) {
				school.selected = true;
				if (this.includeGradeLevels) {
					school.GradeLevels.forEach(gl => {
						gl.selected = true;
					});
				}
				else if (this.includeYears) {
					school.Years.forEach(y => {
						y.selected = true;
					});
				}
			}
		});
	}

	checkAll() {
		this.allSelected = !this.allSelected;
		this.schools.forEach(school => {
				school.checkIndeterminate = false;
			school.selected = this.allSelected;
			if (this.includeGradeLevels) {
				school.GradeLevels.forEach(gl => {
					gl.selected = this.allSelected;
				});
			}
			else if (this.includeYears) {
				school.Years.forEach(y => {
					y.selected = this.allSelected;
				});
			}
		});
	}

	schoolSelected(school: SelectedSite) {
		school.selected = !school.selected;
		if (!school.selected) {
			this.allSelected = false;
			if (this.includeGradeLevels) {
				school.GradeLevels.forEach(gl => {
					gl.selected = false;
				});
			}
			else if (this.includeYears) {
				school.Years.forEach(y => {
					y.selected = false;
				});
			}
			school.checkIndeterminate = false;
		}
		else {
			if (this.includeGradeLevels) {
				school.GradeLevels.forEach(gl => {
					gl.selected = true;
				});
			}
			else if (this.includeYears) {
				school.Years.forEach(y => {
					y.selected = true;
				});
			}
			school.checkIndeterminate = false;
		}
	}


	expandAllClick() {

	}

}
